import { Constants } from "./constants";

export interface IUkcAgilityLevelGroup {
  displayName: string;
  levels: string[];
  sortOrder: number;
  showElement: string; // The show element this group belongs to (Agility or Games)
}

// Predefined order for UKC Agility levels
export const UKC_AGILITY_LEVEL_GROUPS: IUkcAgilityLevelGroup[] = [
  {
    displayName: "Beginner",
    levels: [
      Constants.dog_class_element_level.beginner_a,
      Constants.dog_class_element_level.beginner_b
    ],
    sortOrder: 1,
    showElement: "Agility"
  },
  {
    displayName: "Intermediate",
    levels: [
      Constants.dog_class_element_level.intermediate_a,
      Constants.dog_class_element_level.intermediate_b
    ],
    sortOrder: 2,
    showElement: "Agility"
  },
  {
    displayName: "Excellent",
    levels: [Constants.dog_class_element_level.excellent],
    sortOrder: 3,
    showElement: "Agility"
  },
  {
    displayName: "Novice Hurdles",
    levels: [Constants.dog_class_element_level.novice_hurdles],
    sortOrder: 4,
    showElement: "Games"
  },
  {
    displayName: "Elite Hurdles",
    levels: [Constants.dog_class_element_level.elite_hurdles],
    sortOrder: 5,
    showElement: "Games"
  },
  {
    displayName: "Novice Tunnels",
    levels: [Constants.dog_class_element_level.novice_tunnels],
    sortOrder: 6,
    showElement: "Games"
  },
  {
    displayName: "Elite Tunnels",
    levels: [Constants.dog_class_element_level.elite_tunnels],
    sortOrder: 7,
    showElement: "Games"
  },
  {
    displayName: "3 of a Kind",
    levels: [Constants.dog_class_element_level.three_of_a_kind],
    sortOrder: 8,
    showElement: "Games"
  }
];

// Helper to get display name for a level
export const getDisplayNameForLevel = (level: string): string => {
  const group = UKC_AGILITY_LEVEL_GROUPS.find(g => g.levels.includes(level));
  return group ? group.displayName : level;
};

// Helper to get all levels for a display name
export const getLevelsForDisplayName = (displayName: string): string[] => {
  const group = UKC_AGILITY_LEVEL_GROUPS.find(g => g.displayName === displayName);
  return group ? group.levels : [];
};
